import { Box, Typography } from "@mui/material";
import { StyledHeader } from "../../Common/styles/header";
import Screening from "../../StudyDesigner/Screening";
// import { platformLanguages } from "../../../utils/language";

const PlatformScreener = () => {
  return (
    <>
      <StyledHeader>
        <Typography variant="h2" color="text.primary">
          Screener
        </Typography>
      </StyledHeader>
      <Box
        sx={{
          borderTop: 1,
          borderColor: "#E5E7EB",
          borderBottom: "1px solid #E5E7EB",
          height: "calc(100vh - 132px)",
          overflow: "hidden",
          p: 2.5,
        }}
      >
        <Screening
          canEdit={true}
          canExport={true}
          type="platform"
          languages={[]}
        />
      </Box>
    </>
  );
};
export default PlatformScreener;
